import React from "react";

const TextAreaInput = ({ title, onChange, placeholder }) => {
	const inputRef = React.createRef();
	return (
		<div className="form-group">
			<label className="control-label">{title}</label>

			<textarea
				onChange={e => onChange(e.target.value)}
				ref={inputRef}
				required
				type="text"
				placeholder={placeholder}
				className="form-control-textarea"
				rows="5"
			></textarea>
		</div>
	);
};

export default TextAreaInput;
